import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'uxd-design-system-components';
import './PersonalInfo.scss';
import Spinner from '../../components/Spinner/Spinner';
import StyledModal from '../../components/StyledModal/StyledModal';
import HomeText from '../../components/HomeText/HomeText';
import PersonalInfoForm from '../../components/PersonalInfoForm/PersonalInfoForm';
import Disclaimer from '../../components/Disclaimer/Disclaimer';
import { AnswersContext, LocaleContext, QueryContext } from '../../contexts';
import getText from '../../assets/locale/locale';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';
import ACTIONS from '../../constants/actions';

const PersonalInfo = ({ loading, setCurrentStep, schema, setQuizStarted }) => {
  const [showModal, setShowModal] = useState(false);
  const locId = useContext(LocaleContext);

  useEffect(() => {
    setCurrentStep(window.location.pathname);
    document.title = getText(locId, 'PersonalInfo', 'pageTitle');
  }, []);

  const headerText = getText(locId, 'PersonalInfo', 'modalHeader');
  const paragraphText = getText(locId, 'PersonalInfo', 'modalParagraph');
  const header = getText(locId, 'PersonalInfo', 'header');
  const buttonText = getText(locId, 'PersonalInfo', 'modalButtonText');

  const { answers, answersDispatch } = useContext(AnswersContext);
  const { queryDispatch } = useContext(QueryContext);

  return (
    <main className="form-view form-style">
      {loading ? (
        <div className="spinner-center">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="split-screen">
            <div className="left-screen">
              <HomeText />
            </div>
            <div className="right-screen">
              <div className="form-card">
                <h2>{header}</h2>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                <div
                  role="button"
                  className="why-ask-button"
                  onClick={() => {
                    addDataLayerTrigger('personal-why-ask-button');
                    setShowModal(true);
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 13 || event.keyCode === 32) {
                      addDataLayerTrigger('personal-why-ask-button');
                      setShowModal(true);
                    }
                  }}
                  tabIndex="0"
                >
                  <Icon name="help-question-mark" />
                  {headerText}
                </div>
                <StyledModal
                  headerText={headerText}
                  paragraphText={paragraphText}
                  buttonText={buttonText}
                  displayModal={showModal}
                  closeModalHandler={() => setShowModal(false)}
                />
                <form>
                  <PersonalInfoForm
                    dispatch={queryDispatch}
                    answersDispatch={answersDispatch}
                    ACTIONS={ACTIONS}
                    answers={answers}
                    schema={schema}
                    setQuizStarted={setQuizStarted}
                  />
                </form>
              </div>
            </div>
          </div>
          <Disclaimer />
        </>
      )}
    </main>
  );
};

PersonalInfo.propTypes = {
  loading: PropTypes.bool.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  setQuizStarted: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    dependents: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      })
    ),
    employment_status: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      })
    ),
    hope: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      })
    ),
    marital_status: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      })
    ),
    worry: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default PersonalInfo;
